<template>
    <div class="card-painted" style="padding: 20px">
    <div class="community-manual">
        <v-form>
            <v-tabs v-model="tab"
                    background-color="#fff"
                    color="darkGreyBlue">
                <v-tab @click="toVE" :disabled="isDisabled">Visual Editor</v-tab>
                <v-tab @click="toQuery" :disabled="isDisabled">Query</v-tab>
            </v-tabs>
            <v-tabs-items v-model="currentTab">
                <v-tab-item>
                    <CommunityManualVisualEditor
                            v-model="form"
                            :isQueryValid="isQueryValid">
                    </CommunityManualVisualEditor>
                </v-tab-item>
                <v-tab-item>
                    <CommunityManualQuery
                            v-model="query"
                            :isQueryValid="isQueryValid"
                            :isQueryOnly="isQueryOnly">
                    </CommunityManualQuery>
                </v-tab-item>
            </v-tabs-items>
            <v-card-actions class="btn-container">
                <v-btn class="custom-btn" color="secondary"
                       @click="confirm">Confirm
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>
    </div>
</template>

<script>
    import CommunityManualQuery from "./CommunityRules/CommunityManualQuery";
    import CommunityManualVisualEditor from "./CommunityRules/CommunityManualVisualEditor";
    import {store} from "../../store/store";
    import axios from "axios";

    export default {
        name: "CommunityRules",
        components: {CommunityManualVisualEditor, CommunityManualQuery},
        props: { 'edit': Array, 'nonempty': Boolean  },
        data: () => ({
            // use separate vars for tab selector and actual tabs,
            // this allows to switch tab only after checking correctness of form/query
            tab: 0,
            currentTab: 0,
            query: '',
            form: [],
            isQueryValid: true,
            isPending: false,
            isQueryOnly: false
        }),
        computed: {
            isDisabled: function () {
                return this.isPending && !this.isQueryValid
            }
        },
        methods: {
            theQuery () {
                const token = store.state.accessToken;
                if (this.tab == 0) {
                    return axios.post("/community/query/verifyVE",
                                      { kind: "RuleCreator",
                                        value: this.form }, {
                                          headers: {"Authorization": "Bearer " + token,
                                                    "Content-type": "application/json"}
                                      })
                        .then(resp => resp.data)
                } else {
                    return axios.post("/community/query/verify",
                                      JSON.stringify(this.query), {
                                          headers: {"Authorization": "Bearer " + token,
                                                    "Content-type": "application/json"}
                                      })
                        .then(resp => this.query)
                }
            },
            toQuery () {
                this.theQuery().then(q => {
                        this.isQueryValid = true
                        this.currentTab = 1
                        this.query = q
                }).catch( err => {
                    this.query = ""
                    this.isQueryValid = false
                    this.tab = 0
                })
            },
            toVE () {
                const token = store.state.accessToken;
                axios.post("/community/query/verify",
                           JSON.stringify(this.query), {
                            headers: {"Authorization": "Bearer " + token,
                                      "Content-type": "application/json"}
                           }).then(resp => {
                               // TODO fix handling case where kind is different
                               this.form = resp.data.value
                               this.currentTab = 0
                           }).catch(err => {
                               this.currentTab = 1
                               // TODO fix handling of VennDiagram type of communities,
                               // and query than cannot be transformed to VE add handler
                           })
            },
            confirm () {
                this.theQuery().then(q => {
                    if (q !== "" || !this.nonempty) {
                        this.query = q
                        this.$emit("update:query", this.query)
                        this.$emit('confirm')
                    } else {
                        e => this.isQueryValid = false
                    }
                }).catch(e => this.isQueryValid = false)
            }
        },
        mounted () {
            if (this.edit) {
                this.form = this.edit
            }
        },
        watch: {
            edit: {
                handler (val, oldVal) {
                    this.form = val
                    if (this.tab === 1) {
                        this.toQuery()
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
